module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Fc-Gd-Hc-Ic-Jb.e55762ee.png";